export enum MortgageCompanies {
  FannieMae = "Fannie Mae",
  FreddieMac = "Freddie Mac",
}

export enum ProjectClassificationsFannieMae {
  PCondominium = "PCondominium",
  QCondominium = "QCondominium",
  RCondominium = "RCondominium",
  SCondominium = "SCondominium",
  TCondominium = "TCondominium",
  UCondominium = "UCondominium",
  VRefiPlus = "v refi plus",
  E_PUD = "E_PUD",
  F_PUD = "F_PUD",
  T_PUD = "T_PUD",
  OneCooperative = "OneCooperative",
  TwoCooperative = "TwoCooperative",
  T_Cooperative = "T_Cooperative",
}

export const ProjectClassificationsFannieMaeDisplayValues: {
  [key in ProjectClassificationsFannieMae]: string;
} = {
  [ProjectClassificationsFannieMae.PCondominium]: "P Limited Review New Detached",
  [ProjectClassificationsFannieMae.QCondominium]: "Q Limited Review Est",
  [ProjectClassificationsFannieMae.RCondominium]: "R Expedited Review Est.",
  [ProjectClassificationsFannieMae.SCondominium]: "S Expedited Review Est. ",
  [ProjectClassificationsFannieMae.TCondominium]: "T Fannie Mae Review",
  [ProjectClassificationsFannieMae.UCondominium]: "U FHA-approved",
  [ProjectClassificationsFannieMae.VRefiPlus]: "V Refi Plus",
  [ProjectClassificationsFannieMae.E_PUD]: "E PUD",
  [ProjectClassificationsFannieMae.F_PUD]: "F PUD",
  [ProjectClassificationsFannieMae.T_PUD]: "T PUD",
  [ProjectClassificationsFannieMae.OneCooperative]: "1 Co-op",
  [ProjectClassificationsFannieMae.TwoCooperative]: "2 Co-op",
  [ProjectClassificationsFannieMae.T_Cooperative]: "T Co-op",
};

export enum ProjectClassificationsFreddieMac {
  IIICondominium = "IIICondominium",
  IICondominium = "IICondominium",
  ICondominium = "ICondominium",
  DetachedProject = "DetachedProject",
  TwoToFourUnitProject = "TwoToFourUnitProject",
  ReciprocalReview = "ReciprocalReview",
}

export const ProjectClassificationsFreedieMacDisplayValues: {
  [key in ProjectClassificationsFreddieMac]: string;
} = {
  [ProjectClassificationsFreddieMac.IIICondominium]: "Streamlined Review",
  [ProjectClassificationsFreddieMac.IICondominium]: "Established Project",
  [ProjectClassificationsFreddieMac.ICondominium]: "New Project",
  [ProjectClassificationsFreddieMac.DetachedProject]: "Detached Project",
  [ProjectClassificationsFreddieMac.TwoToFourUnitProject]: "2-to-4 unit Project",
  [ProjectClassificationsFreddieMac.ReciprocalReview]: "Reciprocal Review",
};
